/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const RegionPage = lazy(() => import('./pages/RegionPage'))
const YearBornPage = lazy(() => import('./pages/YearBornPage'))
const NewZealandNLIHP = lazy(() => import('./pages/NewZealandNLIHP'))

export default [
  <SiteRoute key="nlihp" exact path="/" component={NewZealandNLIHP} />,
  <SiteRoute key="region" path="/region/:region" component={RegionPage} />,
  <SiteRoute key="year-i-was-born" exact path="/year-born/:year" component={YearBornPage} />,
]
